<!-- =========================================================================================
  File Name: Create.vue
  Description: Device Create Page
========================================================================================== -->


<template>
  <div id="apps-devices-create">

    <vx-card>

      <div slot="no-body" class="tabs-container px-6 pt-6">

        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">

          <vs-tab label="Главная" icon-pack="feather" icon="icon-file-text">
            <div class="tab-text">
              <tab-main class="mt-4" :device="device_data" />
            </div>
          </vs-tab>

        </vs-tabs>

      </div>

    </vx-card>
  </div>
</template>

<script>
import TabMain from "./TabMain.vue"

// Store Module
import moduleDevice from '@/store/device/moduleDevice.js'

export default {
  components: {
    TabMain,
  },
  data() {
    return {
      device_data: {},
      activeTab: 0,
    }
  },
  computed: {
    programs_data() {
      return this.$store.state.device.programs
    },

  },
  watch: {
    activeTab() {
    }
  },
  methods: {
  },
  created() {
    if (!moduleDevice.isRegistered) {
      this.$store.registerModule('device', moduleDevice)
      moduleDevice.isRegistered = true
    }
    this.$store.dispatch("device/fetchDevices")
  }
}

</script>
